module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-8-63c7ca315323c8462c85640374ef03c6.svg";